import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tic: 0,
  requests_cnt: 0,
};

const ticSlice = createSlice({
  name: 'tic',
  initialState,
  reducers: {
    setTic: (state, action) => {
      state.tic = action.payload;
    },
    incrementTic: (state) => {
      state.tic += 1;
    },
    setRequestsCnt: (state, action) => {
      state.requests_cnt = action.payload;
    },
    incrementRequestsCnt: (state) => {
      state.requests_cnt += 1;
    },
    resetTic: (state) => {
      state.tic = 0;
      state.requests_cnt = 0;
    },
  },
});

export const { setTic, incrementTic, setRequestsCnt, incrementRequestsCnt, resetTic } =
  ticSlice.actions;

export default ticSlice.reducer;
